import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/slitherlink.json";
import fr from "@/locales/fr/puzzle-types/slitherlink.json";

export const SLITHERLINK_NS = "puzzle-types/slitherlink";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerSlitherlinkTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", SLITHERLINK_NS))
    i18n.addResourceBundle("en", SLITHERLINK_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", SLITHERLINK_NS))
    i18n.addResourceBundle("fr", SLITHERLINK_NS, fr, true, true);
}
